module.exports = __webpack_public_path__ + "assets/img/side_left_arrow.a1dd6654.png";